import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../utils/apk";
import { toast } from "react-toastify";

function BusinessInfo() {
  const [formData, setFormData] = useState({
    businessName: "",
    mobileNo: "",
    address: "",
    gstNo: "",
  });

  const [logoFile, setLogoFile] = useState(null);
  const [adminId, setAdminId] = useState(null);
  const [isBusinessCreated, setIsBusinessCreated] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedAdminId = localStorage.getItem("adminId");
    if (storedAdminId) {
      setAdminId(storedAdminId);
      fetchAndSetBusiness(storedAdminId);
    }
  }, []);

  const fetchAndSetBusiness = async (adminId) => {
    try {
      const res = await axios.get(`${API}/get/all/business`);
      if (res.data?.data?.length > 0) {
        const business = res.data.data[0];
        setFormData({
          businessName: business.businessName || "",
          mobileNo: business.mobileNo || "",
          address: business.address || "",
          gstNo: business.gstNo || "",
        });
      }
    } catch (err) {
      console.error("Error fetching business info:", err);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogoChange = (e) => {
    setLogoFile(e.target.files[0]);
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("businessName", formData.businessName);
      form.append("mobileNo", formData.mobileNo);
      form.append("address", formData.address);
      form.append("gstNo", formData.gstNo);
      if (logoFile) form.append("image", logoFile);

      await axios.post(`${API}/create/business`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Submitted");
    } catch (err) {
      console.error("Create error:", err);
      toast.error("Business Created Successfully!");
    } finally {
      setIsBusinessCreated(true); // ✅ Force to Update mode
      setLoading(false);
      if (adminId) await fetchAndSetBusiness(adminId);
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("businessName", formData.businessName);
      form.append("mobileNo", formData.mobileNo);
      form.append("address", formData.address);
      form.append("gstNo", formData.gstNo);
      if (logoFile) form.append("image", logoFile);

      await axios.put(`${API}/update/business`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Updated");
    } catch (err) {
      console.error("Update error:", err);
      toast.error("Update failed");
    } finally {
      setLoading(false);
      if (adminId) await fetchAndSetBusiness(adminId);
    }
  };

  return (
    <div className="flex justify-center flex-col items-center h-full my-8 bg-blue-200">
      <div className="w-full max-w-6xl p-8 bg-white shadow-lg mb-4 rounded-lg">
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
          {isBusinessCreated ? "Update Business Information" : "Add Your Business Information"}
        </h2>

        <form
          onSubmit={isBusinessCreated ? handleUpdateSubmit : handleCreateSubmit}
          className="grid grid-cols-3 gap-6"
          encType="multipart/form-data"
        >
          {/* Column 1 */}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 font-bold mb-2">Business Name</label>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Enter Business Name"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-bold mb-2">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Enter Address"
              />
            </div>
          </div>

          {/* Column 2 */}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 font-bold mb-2">Mobile No</label>
              <input
                type="text"
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Enter Mobile No"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-bold mb-2">GST No</label>
              <input
                type="text"
                name="gstNo"
                value={formData.gstNo}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Enter GST No"
              />
            </div>
          </div>

          {/* Column 3 */}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 font-bold mb-2">Upload Company Logo</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                className="w-full px-3 py-2 border rounded-lg bg-white"
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="col-span-3 flex justify-center mt-6">
            <button
              type="submit"
              disabled={loading}
              className={`bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              {loading ? "Please wait..." : isBusinessCreated ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BusinessInfo;
